import React from 'react';
import { cx } from '../cx';

// 신호등 점 — 공종 진행 신호 전용 (D-08 §6.15 primitive.signal.*, D-07 §1.2 신호등 예외).
// 신호등 외 상태 표시(배지·알림)에는 쓰지 않는다. 점 단독으로 의미를 전달하지 않도록 호출부가 숫자·글자를 곁들인다.
//  · WHITE  = 빈 원(테두리만, --shell-border)
//  · NONE   = 빗금 원(해당 없음, --shell-border 대각선)
//  · YELLOW/RED/GREEN/BLUE = --signal-* 채움
// contract 없는 손 작성 컴포넌트(Drawer.tsx와 동일 예외) — 클래스는 styles/components.css(.signal-dot).
export type SignalDotColor = 'WHITE' | 'YELLOW' | 'RED' | 'GREEN' | 'BLUE' | 'NONE';

export interface SignalDotProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'color'> {
  color: SignalDotColor;
  /** 지름(px). 기본 10. */
  size?: number;
  /** 스크린리더용 이름(예: '반장 신호 노랑'). 없으면 장식 요소로 숨김. */
  label?: string;
}

export function SignalDot({ color, size = 10, label, className = '', style, ...props }: SignalDotProps) {
  const a11y = label ? { role: 'img' as const, 'aria-label': label } : { 'aria-hidden': true as const };
  return (
    <span
      className={cx('signal-dot', `signal-dot-${color.toLowerCase()}`, className)}
      style={{ '--signal-dot-size': `${size}px`, ...style } as React.CSSProperties}
      {...a11y}
      {...props}
    />
  );
}

/** 점 여러 개를 한 줄로 묶는다(간격 = --num-4). 간트 막대 옆 3점 등. */
export function SignalDots({ className = '', children, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return <span className={cx('signal-dots', className)} {...props}>{children}</span>;
}
